import { cn } from '@fortem-monorepo/js-utilities'
import { Badge } from '@fortem-monorepo/react-ui'
import { PnlAttributions } from '@fortem-monorepo/web-sdk'

import { attributionTypeBadgeClassnames } from '@/pages/pnl-attributions/constants'

export interface AttributionTypeBadgeProps {
  attribution_type: PnlAttributions.AttributionType
}

export const AttributionTypeBadge: React.FC<AttributionTypeBadgeProps> = ({ attribution_type }) => {
  return <Badge className={cn(attributionTypeBadgeClassnames[attribution_type])}>{attribution_type}</Badge>
}
